import { Controller } from "@hotwired/stimulus"

// Smooth-scrolls to an in-page section WITHOUT writing the hash to the URL. The landing's
// CTAs used <a href="#collection">, which leaves #collection in the URL after a tap — and on
// iOS Safari a refresh then re-jumps to that anchor (landing on "La collection" instead of the
// top). Intercepting the click and scrolling manually keeps the URL clean, so a refresh starts
// at the top. data-astro-lp-anchor-target-value holds the target id (default "collection").
// Classic JS only (old Babel — no ?./??).
export default class extends Controller {
  static values = { target: { type: String, default: "collection" } }

  scroll(event) {
    const el = document.getElementById(this.targetValue)
    if (!el) return // let the browser handle it if the section is missing
    event.preventDefault()
    el.scrollIntoView({ behavior: "smooth", block: "start" })
  }
}
